import { CategoryRouteComponent } from '@jane/bloom/components/routes/category/categoryRouteComponent';

export {
  clientLoader,
  links,
  loader,
  meta,
} from '@jane/bloom/routes/_menu.($storeSlug).shop-all._index/route';
export { productGridShouldRevalidate as shouldRevalidate } from '@jane/bloom/utils/routes/shouldRevalidate';

export default CategoryRouteComponent;
